import { RouterProvider } from 'react-router-dom';

import { router } from '../app-routes';

export const Router = () => <RouterProvider router={router} />;
